<template>
  <div class="custom-container mb-5">
    <div class="animated-bg">
      <vue-particles
          color="#0033AA"
          :particleOpacity="0.7"
          :particlesNumber="80"
          shapeType="circle"
          :particleSize="4"
          linesColor="#0033AA"
          :linesWidth="1"
          :lineLinked="true"
          :lineOpacity="0.4"
          :linesDistance="150"
          :moveSpeed="3"
          :hoverEffect="true"
          hoverMode="grab"
          :clickEffect="true"
          clickMode="push"
      >
      </vue-particles>
    </div>
    <div class="inner-content container">
      <v-row class="container mx-0 px-0" align-content="center">
        <v-col cols="12" md="6" lg="6" xl="6" class="left">
          <div>
            <div class="large-text animate__animated animate__bounce study-anywhere">
              Study from anywhere with Experts and Great Materials
            </div>
            <br/>
            <div class="msg">
              <div class="wrapper">
                <typewriter
                    :speed="200"
                    :full-erase="true"
                    :cursor="true"
                    :interval="300"
                    :words='typeWriterWords'
                >Join as a
                </typewriter>
              </div>
            </div>
            <br/>
            <br/>
            <p class="normal-text">
              We know sometimes you wonder if you'll be in a better position in your career,
              but do you really know exactly what it is? join us
              today and we guide you to what you can really do best.
            </p>
            <v-row v-if="!isAuthenticated">
              <v-col cols="12" md="4" lg="4">
                <v-btn to="/signup" block color="primary" class="animate__animated animate__slideInLeft">Get Started</v-btn>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-btn to="/signup" block outlined color="primary" class="animate__animated animate__slideInRight">Learn More</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="6" xl="6">
          <lottie-animation
              ref="anim"
              :animationData="require('@/assets/animations/first_animation.json')"
              :loop="true"
              :autoPlay="true"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue'
import HomeBannerImage from "@/assets/home-banner.svg";
import {mapGetters} from 'vuex';
export default {
  components:{
    LottieAnimation
  },
  data() {
    return {
      typeWriterWords: [
        "Student and enjoy the learning experience.",
        "Mentor and earn more academic reputation.",
        "Parent to track your child's growth."
      ],
      HomeBannerImage
    };
  },
  computed: {
    ...mapGetters({isAuthenticated: "auth/GET_IS_AUTHENTICATED"})
  }
};
</script>

<style lang="scss">
@import "~vuetify/src/styles/settings/_variables";

.large-text {
  font-size: 2.6em;
  font-weight: bolder;
}
.normal-text {
  font-size: 1.4em;
}

.msg {
  font-size: 1.9em;
  font-weight: bolder;
}
 .wrapper .typewriter-msg {
  color: #ff0048;
  font-weight: 600;
}
.wrapper {
    height: 13vh;
}

.animated-bg {
  position: absolute;
  width: 95%;
  color: white;
  opacity: 1;
  z-index: 1;
}

.inner-content {
  position: relative;
}

.left {
    margin: 2rem 0
}

.custom-container {
  height: auto;
}

.v--vtt-test,
.v--vtt-test_odd {
  will-change: transform, opacity;
  transition: opacity 0.3s ease-in-out, transform 1s ease-in-out;
}

.v--vtt-test_visible,
.v--vtt-test_odd_visible {
  opacity: 1;
  transform: translateY(0);
}

.v--vtt-test_hidden {
  opacity: 0;
  transform: translateY(20px);
}

.v--vtt-test_odd_hidden {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
